// The signed-in user's session token (from the email-code sign-in) — public
// /app endpoints send it so the backend can also serve the account's data.
export function getUserToken() {
  try { return localStorage.getItem("userToken") || ""; } catch { return ""; }
}

export function isUserLoggedIn() {
  return !!getUserToken();
}

export function userHeaders(extra = {}) {
  const token = getUserToken();
  return token ? { ...extra, Authorization: `Bearer ${token}` } : extra;
}
